import { VFC, useState } from 'react'
import { useMasterData } from 'src/api/masterData'
import { updatePersona, usePersona } from 'src/api/persona'
import { withLoginUser } from 'src/api/user'
import { CompanyPersonasForm } from './CompanyPersonasForm'
import { GET_PERSONAS } from 'src/api/endpoints'
import { useSWRConfig } from 'swr'

export const CompanyPersonasEdit: VFC<{
  personaId: number
  close: () => void
}> = withLoginUser(({ user, personaId, close }) => {
  const { mutate } = useSWRConfig()
  const { data: personaData, isValidating } = usePersona(personaId)
  const { data: masterData } = useMasterData()
  const [errorMessages, setErrorMessages] = useState<string[]>([])
  if (isValidating || !personaData || !masterData) return <></>

  return (
    <CompanyPersonasForm
      user={user}
      personaData={personaData}
      masterData={masterData}
      errorMessages={errorMessages}
      submit={async (data) => {
        const res = await updatePersona(personaId, data)
        if (res.data?.success) {
          mutate(GET_PERSONAS)
          close()
        } else if (res.error) setErrorMessages(res.error.errorMessages)
      }}
    />
  )
})
